import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoConvenioFormaDesembolso } from '../_models/producto-convenio-forma-desembolso';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductoConvenioFormaDesembolsoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosConveniosFD/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as ProductoConvenioFormaDesembolso[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as ProductoConvenioFormaDesembolso ) );
  }

  listadoPorProducto( id: string ) {
    return this.httpClient.get( this.rutServicio + 'producto/' + id ).pipe( map( res => res as ProductoConvenioFormaDesembolso[] ) );
  }

  listadoPorProductoFormaDesembolso( id: string ) {
    return this.httpClient.get( this.rutServicio + 'productoFormaDesembolso/' + id )
      .pipe( map( res => res as ProductoConvenioFormaDesembolso[] ) );
  }

  crear( regCrear: ProductoConvenioFormaDesembolso ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoConvenioFormaDesembolso ) );
  }

  actualizar( regActualizar: ProductoConvenioFormaDesembolso ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( list: ProductoConvenioFormaDesembolso[] ): Observable<ProductoConvenioFormaDesembolso[]> {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    list.forEach( x => x.auditoriaUsuario = auditoriaUsuario );
    return this.httpClient.post( this.rutServicio + 'bulk', list ).pipe( map( res => res as ProductoConvenioFormaDesembolso[] ) );
  }

}
